import { Link } from 'react-router-dom'
import PageHero from '../components/PageHero'
import PageSeo from '../components/PageSeo'
import SiteFooter from '../components/SiteFooter'
import TopNav from '../components/TopNav'
import { buildOrganizationSchema, getAbsoluteUrl } from '../lib/seo'
import './ArticlePage.css'

const effectiveDate = '2026-05-04'

export default function PrivacyPolicyPage() {
  return (
    <div className="article-page">
      <PageSeo
        title="Privacy Policy | Contrast Shower"
        description="Read the Contrast Shower app privacy policy, including information collection, retention, security, and contact details."
        canonical={getAbsoluteUrl('/privacy-policy')}
        image={getAbsoluteUrl('/images/blog-placeholder-basics.svg')}
        keywords={['contrast shower privacy policy', 'privacy policy', 'contrast shower app privacy']}
        schema={[buildOrganizationSchema()]}
      />

      <TopNav />

      <main>
        <article className="article-shell">
          <PageHero as="header" innerClassName="article-hero__inner">
            <nav className="article-breadcrumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Privacy Policy</span>
            </nav>

            <p className="eyebrow eyebrow--blog">Legal</p>
            <h1 className="article-hero__title heading-light">Privacy Policy</h1>
            <p className="article-hero__description p-intro">
              This privacy policy applies to the Contrast Shower app for mobile devices.
            </p>

            <div className="article-hero__meta">
              <span>Effective date</span>
              <span>{effectiveDate}</span>
            </div>
          </PageHero>

          <div className="container article-body-wrap">
            <div className="article-layout article-layout--single">
              <div className="article-content article-content--legal">
                <p className="article-intro">
                  This privacy policy applies to the "Contrast Shower" app (hereby referred to as "Application") for mobile devices(hereby referred to as "Service Provider") as a Freemium service. This service is intended for use "AS IS".
                </p>

                <section className="article-section">
                  <h2>Information Collection and Use</h2>
                  <p>
                    The Application collects information when you download and use it. This information may include information such as:
                  </p>
                  <div className="article-list-block">
                    <ul>
                      <li>Your device&apos;s Internet Protocol address (e.g. IP address)</li>
                      <li>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
                      <li>The time spent on the Application</li>
                      <li>The operating system you use on your mobile device</li>
                    </ul>
                  </div>
                  <p>
                    The Application does not gather precise information about the location of your mobile device.
                  </p>
                  <p>
                    The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.
                  </p>
                  <p>
                    For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information. The information that the Service Provider request will be retained by them and used as described in this privacy policy.
                  </p>
                </section>

                <section className="article-section">
                  <h2>Third Party Access</h2>
                  <p>
                    Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.
                  </p>
                  <p>The Service Provider may disclose User Provided and Automatically Collected Information:</p>
                  <div className="article-list-block">
                    <ul>
                      <li>as required by law, such as to comply with a subpoena, or similar legal process;</li>
                      <li>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;</li>
                      <li>with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.</li>
                    </ul>
                  </div>
                </section>

                <section className="article-section">
                  <h2>Opt-Out Rights</h2>
                  <p>
                    You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
                  </p>
                </section>

                <section className="article-section">
                  <h2>Data Retention Policy</h2>
                  <p>
                    The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you&apos;d like them to delete User Provided Data that you have provided via the Application, please contact them at support@contrastshower.com and they will respond in a reasonable time.
                  </p>
                </section>

                <section className="article-section">
                  <h2>Children</h2>
                  <p>
                    The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
                  </p>
                  <p>
                    The Service Provider does not knowingly collect personally identifiable information from children. The Service Provider encourages all children to never submit any personally identifiable information through the Application and/or Services. The Service Provider encourage parents and legal guardians to monitor their children&apos;s Internet usage and to help enforce this Policy by instructing their children never to provide personally identifiable information through the Application and/or Services without their permission. If you have reason to believe that a child has provided personally identifiable information to the Service Provider through the Application and/or Services, please contact the Service Provider at test@gmail.com so that they will be able to take the necessary actions. You must also be at least 16 years of age to consent to the processing of your personally identifiable information in your country (in some countries we may allow your parent or guardian to do so on your behalf).
                  </p>
                </section>

                <section className="article-section">
                  <h2>Security</h2>
                  <p>
                    The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
                  </p>
                </section>

                <section className="article-section">
                  <h2>Changes</h2>
                  <p>
                    This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
                  </p>
                  <p>This privacy policy is effective as of {effectiveDate}</p>
                </section>

                <section className="article-section">
                  <h2>Your Consent</h2>
                  <p>
                    By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
                  </p>
                </section>

                <section className="article-section">
                  <h2>Contact Us</h2>
                  <p>
                    If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at support@contrastshower.com.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </article>
      </main>

      <SiteFooter />
    </div>
  )
}
